// adding some validations logic for galleries form
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export const FORM_GALLERIES_VALIDATIONS = {
  dataForm: {
    galleryType: {
      required
    },
    galleryLink: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(255)
    },
    gallerySrc: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(255)
    },
    galleryDescription: {
      minLength: minLength(5),
      maxLength: maxLength(255)
    },
    galleryTitle: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(100),
    }
  }
};



// WEBPACK FOOTER //
// ./src/validations/formGalleries.js